module.exports = __webpack_public_path__ + "static/media/juniper-frame.5459826b.png";